import { SpecificationFormRule } from './specification-form-rule';

export class CreditRule {
  public static rule(): SpecificationFormRule {
    return {
      fields: {
        postalCode: {
          display: false,
          required: false
        },
        address1: {
          display: false,
          required: false
        },
        address2: {
          display: false,
          required: false
        },
        name: {
          display: true,
          required: true,
          headingKey: 'project-name'
        },
        projectType: {
          display: true,
          required: true
        },
        description: {
          display: false,
          required: false
        },
        map: {
          display: false,
          required: false
        },
        country: {
          display: false,
          required: false
        },
        state: {
          display: false,
          required: false
        },
        city: {
          display: false,
          required: false
        },
        latitude: {
          display: false,
          required: false
        },
        longitude: {
          display: false,
          required: false
        },
        cod: {
          display: false,
          required: false
        },
        tenderProject: {
          display: false,
          required: false
        },
        currency: {
          display: false,
          required: false
        },
        exchangeRate: {
          display: false,
          required: false
        },
        program: {
          display: false,
          required: false
        },
        status: {
          display: false,
          required: false
        }
      },
      keys: {
        header: 'site-location',
        info: 'basic-info',
        location: 'claim-location',
        currency: 'tariff'
      }
    };
  }
}
